<ion-content padding="true" class="manual-ios-statusbar-padding" scroll="false">

  <div class="loginAppPage">

    <div class="wrapper" [style.padding-bottom.px]="utils.keyboardHeight">
      <div>
        <img src="assets/imgs/colorLogo.png" class="logo" data-cy="login-logo" />
      </div>
      <div class="spacer-32"></div>
      <form lines="none" #form id="form" (ngSubmit)="login()" [formGroup]="loginForm" class="center-form">
        <p *ngIf="loginAttempt" style="color: #ea6153;" data-cy="login-error">{{loginError}}</p>

        <ion-item>
          <ion-label class="hide" color="grey" position="floating" data-cy="login-form-email-txt">Email</ion-label>
          <ion-input label="Email" labelPlacement="floating" mode="ios" #email id="email"
            (change)="loginForm.controls['email'].setValue($event.target.value)"
            [class.invalid]="!loginForm.controls.email.valid && (loginForm.controls.email.dirty|| loginAttempt)"
            type="email" name="email" inputmode="email" value="" autocomplete="email" formControlName="email"
            label-placement="floating" (ionBlur)="resetEmail()" (ionFocus)="resetEmail()"
            data-cy="login-form-email-input"></ion-input>
        </ion-item>
        <div *ngIf="!emailValid" data-cy="login-form-email-errorMsg">
          <span class="errorMsg">{{ i8nService.messages.loginEnterEmailAddress}}</span>
        </div>

        <ion-item lines="none">
          <ion-label class="hide" color="grey" position="floating"
            data-cy="login-form-password-txt">Password</ion-label>
          <ion-input label="Password" labelPlacement="floating" mode="ios" #password id="password"
            (keyup.enter)="login()" (change)="loginForm.controls['password'].setValue($event.target.value)"
            label-placement="floating"
            [class.invalid]="!loginForm.controls.password.valid && (loginForm.controls.password.dirty|| loginAttempt)"
            type="password" name="password" autocomplete="password" inputmode="password" formControlName="password"
            (ionBlur)="resetPassword()" (ionFocus)="resetPassword()" data-cy="login-form-passw-input">
          </ion-input>
        </ion-item>

        <div *ngIf="!passwordValid" data-cy="login-form-password-errorMsg">
          <span class="errorMsg">{{ i8nService.messages.loginPleaseEnterPassword }}</span>
        </div>
        <div class="spacer-28"></div>

        <ion-button [disabled]="disableLogin" expand="block" inputmode="" type="submit" color="primary" full
          data-cy="login-form-logInBtn">
          <ion-label *ngIf="!disableLogin">Log in</ion-label>
          <ion-spinner *ngIf="disableLogin" class="ionSpinner" name="crescent"></ion-spinner>
        </ion-button>

        <p tappable (click)="onForgotPasswordClick()" class="text-center" data-cy="login-forgotPasswordBtn"> Forgot
          Password?</p>

        <ion-button fill="clear" type="button" color="primary" (click)="goToSignUp()" expand="full"
          data-cy="login-createAccBtn">Or create an account
        </ion-button>
      </form>
    </div>

  </div>
</ion-content>